import { IQuery, Condition } from "@cayo/shared/components/GridContainer/types";

export function resetToDefault(query: IQuery, mainQueryId: string, mainQueryName: string) {
  const cloneQuery = structuredClone(query);
  return {
    ...cloneQuery,
    id: mainQueryId,
    name: mainQueryName,
    conditions: cloneQuery?.conditions?.filter((c: Condition) => c.kind === "advanced"),
  };
}
